var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qk-image"},[_c('img',{attrs:{"src":_vm.imageSrc,"alt":"","crossOrigin":"anonymous"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }